<template>
  <div v-if="catalogHasPhysicalItems">
    <slot />
  </div>
</template>

<script>
import { GET_CATALOG } from '@/store/get-types'
import { FulfillmentType } from '@/cowboy/EnumTypes'
import { mapGetters } from 'vuex'
export default {
  name: 'DisplayIfCatalogHasPhysicalItems',
  computed: {
    catalogHasPhysicalItems () {
      const { brands = [] } = this.catalog || {}
      return brands.filter(this.brandHasPhysicalItems).length > 0
    },
    ...mapGetters({
      catalog: GET_CATALOG
    })
  },
  methods: {
    brandHasPhysicalItems (brand) {
      return brand.items.find(
        item => item.fulfillmentType === FulfillmentType.PHYSICAL
      )
    }
  }
}
</script>
